import { formatDate } from "@/lib/utils"
import type { Activity } from "../../Boards/types"

function describe(activity: Activity): string {
  switch (activity.action) {
    case "created":
      return "filed this ticket"
    case "moved":
      return activity.from ? `moved it from ${activity.from} to ${activity.to}` : `moved it to ${activity.to}`
    case "assigned":
      return `assigned it to ${activity.to}`
    case "unassigned":
      return activity.from ? `took it off ${activity.from}` : "unassigned it"
    case "priority":
      return `set priority to ${activity.to}`
    case "due_on":
      return activity.to ? `set the due date to ${formatDate(activity.to)}` : "cleared the due date"
    case "estimate":
      return activity.to ? `estimated it at ${activity.to}h` : "cleared the estimate"
    default:
      return "changed this ticket"
  }
}

function when(iso: string) {
  return new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  })
}

export function ActivityFeed({ activities }: { activities: Activity[] }) {
  if (activities.length === 0) {
    return <p className="text-muted-foreground text-sm">Nothing has happened to this ticket yet.</p>
  }

  return (
    <ol className="space-y-2">
      {activities.map((activity) => (
        <li key={activity.id} className="text-muted-foreground flex flex-wrap items-baseline gap-x-1.5 text-sm">
          <span className="text-foreground font-medium">{activity.actor?.name ?? "Someone"}</span>
          <span>{describe(activity)}</span>
          <span className="text-xs">· {when(activity.created_at)}</span>
        </li>
      ))}
    </ol>
  )
}
